import { Chatroom } from '../../../Chatroom'
import Modal, { Box } from '../../../Modal'

function RequestProfileTabChatsFullScreenModal({
  buildingId,
  createChatroomParams,
  filePreviewProps,
  isPrivate,
  isPublic,
  messageDraftRef,
  outboundUuid,
  requestId,
  requestPermissions,
  title,
  uuid,
  visibleToDwellers,
  onChatroomCreated,
  onClose,
  onMessageDeleted,
  onMessageSent,
  onReadBottomReached,
}) {
  return (
    <Modal onClose={onClose}>
      <Box isFullScreen>
        <Chatroom
          isFullScreen
          buildingId={buildingId}
          createChatroomParams={createChatroomParams}
          filePreviewProps={filePreviewProps}
          isPrivate={isPrivate}
          isPublic={isPublic}
          messageDraftRef={messageDraftRef}
          outboundUuid={outboundUuid}
          requestId={requestId}
          requestPermissions={requestPermissions}
          title={title}
          uuid={uuid}
          visibleToDwellers={visibleToDwellers}
          onChatroomCreated={onChatroomCreated}
          onMessageDeleted={onMessageDeleted}
          onMessageSent={onMessageSent}
          onReadBottomReached={onReadBottomReached}
          onToggleFullScreen={onClose}
        />
      </Box>
    </Modal>
  )
}

export default RequestProfileTabChatsFullScreenModal
